import { gql } from '@apollo/client';

export const ARCHIVE_ECD_REGISTRATION = gql`
  mutation archiveEcdRegistration($id: ID!) {
    ecdRegistration: archiveEcdRegistration(id: $id) {
      id
    }
  }
`;
